<template>
  <!-- 内容主体 -->
  <div class="box">
    <p class="title">{{ content.name }}</p>
    <p class="time">版本：{{ content.version }} </p>
    <p class="time">时间：{{ formatDate(content.createTime) }}</p>
    <div v-html="content.fullText"></div>
  </div>
</template>

<script>
export default {
  props: {
    content: {},
  },
  data() {
    return {};
  },
  components: {},
  //
  created() {},
  methods: {
    formatDate(time) {
      if (!time) return "";
      return String(time).replace("T", " ").slice(0, 10);
    },
  },
};
</script>

<style scoped lang="less">
// 内容主体
.box {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 20px;
  word-break: break-word;
  overflow-wrap: break-word;
  .title {
    font-size: 20px;
    color: #333333;
    text-align: center;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .time {
    text-align: right;
    font-size: 14px;
    color: #666666;
    margin-bottom: 5px;
  }
  /deep/p {
    font-size: 14px;
    color: #666666;
    letter-spacing: 1.5px;
    line-height: 30px;
    font-weight: 400;
    text-indent: 30px;
  }
  /deep/img {
    max-width: 100%;
    width: auto;
    height: auto;
    max-height: 250px;
    margin: 0 auto !important;
    display: block;
    border: 1px solid #b7b7b7;
  }
  /deep/table {
    max-width: 100%;
    overflow-x: auto;
    display: block;
  }
}
</style>
